// extracted by mini-css-extract-plugin
export default {"wrapper":"FinancialTransactionsReportFilters_wrapper__A96my"};